export default __webpack_public_path__ + "static/media/feature2-2.49ef6fa5.png";